import { PolylineProps } from "react-leaflet";

export class Route {
    id: string;
    name: string;
    polyline: PolylineProps["positions"];
    color: string;
    visibleOnMap: boolean;
}
